import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/footer/footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/MobileBookNow.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/Vietnam-Combodia/PopupForm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/Vietnam-Combodia/VietnamBanner.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/Vietnam-Combodia/Vietnamclients.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/Vietnam-Combodia/VietnamFaqAccordion.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/Vietnam-Combodia/Vietnamherosection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/Vietnam-Combodia/Vietnamincludedsection.js");
;
import(/* webpackMode: "eager" */ "/Users/vijay/Desktop/sst-internationals/src/components/Vietnam-Combodia/Vietnammainbanner.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/Vietnam-Combodia/VietnamPackages.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/Vietnam-Combodia/VietnamTestimonialsSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/Vietnam-Combodia/VietnamTourInfoTabs.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/Vietnam-Combodia/VietnamWhychoosesection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/WhatsAppChatWidget.js");
